import type { FaireProductEntity } from "../../entity_types/product";

export const p_ku9gn8wpfy: FaireProductEntity = {
  token: "p_ku9gn8wpfy",
  type: "product",
  name: "H LINX Layered Bracelet Starter Package- 8 Assorted",
  brandToken: "b_84csx48g4t",
  brandName: "Center Court",
  imageUrl:
    "https://cdn.faire.com/fastly/6a18d28fc5cc0dc94659f8e6628b55b2c389c71822d011be6152e0695ad03473.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d57f1bc4bdec577c96d18e0ea0f65d02ebf4cfa79135f44c2ae81ea260e5e3a0.jpeg",
    "https://cdn.faire.com/fastly/69b514cc118fa622439a9c36ecf8a12b97b28705b00b1cfc70cbddb80a86a3dd.jpeg",
    "https://cdn.faire.com/fastly/41eadd22df23e0967c665aac346a890229aa34d310509230706c696979b512d0.png",
  ],
  priceDollars: 727,
  description:
    'LINX: Layered Bracelet Starter Package- 8 Assorted Base Bracelets, 5ea (40pcs x $7.25) 30 Assorted LINX Styles, 92 total (92pcs x $4.75) Free Display, 70"x 21"x 13" ($500 Value)\n\nMade of brass with 10k gold overlay & stainless steel and sealed with an acrylic finish\nDisplay is 2-Sided Spinner Amish Made, Mahogany Wood\nLifetime warranty',
  tags: [],
  msrpDollars: 1994.68,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:27:03.142Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
